import React from "react";
import { Skeleton, Box, Divider } from "@mui/material";
import Grid from "@mui/material/Grid2";

const ReservationsClientVoucherSkeleton = ({ lgUp }) => (
  <Box>
    <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
      <Grid item xs={8} sm={8} lg={7}>
        <Skeleton variant="text" width={220} height={40} />
      </Grid>
      <Grid item xs={4} sm={4} lg={5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Skeleton variant="rectangular" width={140} height={40} />
      </Grid>
    </Grid>

    <Divider sx={{ my: 2 }} />

    <Box sx={{
      background: '#fff',
      borderRadius: 2,
      boxShadow: 1,
      p: { xs: 2, sm: 3 },
      mb: 2
    }}>

      <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
        <Skeleton variant="rectangular" width={1500} height={150} />
      </Box>

      <Box display="flex" justifyContent="center" alignItems="center" py={2}>
        <Skeleton variant="text" width={180} height={48} sx={{ mr: 2 }} />
        <Skeleton variant="rectangular" width={60} height={28} />
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Box mb={2}>
        {[
          [
            { width: "10%", mr: '20%' },
            { width: "20%", mr: '15%' },
            { width: "20%", mr: '15%' },
            { width: "20%", mr: '15%' }
          ],
          [
            { width: "30%", mr: '10%' },
            { width: "20%", mr: '15%' },
            { width: "20%", mr: '15%' },
            { width: "20%", mr: '15%' }
          ],
          ...Array(4).fill([
            { blank: true, width: "10%", mr: '20%' },
            { blank: true, width: "20%", mr: '15%' },
            { width: "20%", mr: '15%' },
            { width: "20%", mr: '15%' }
          ])
        ].map((row, rowIndex) => (
          <Box key={rowIndex} display="flex" mb={rowIndex > 1 ? 2 : 1}>
            {row.map((col, colIndex) => (
              col.blank ? (
                <Box key={colIndex} sx={{ width: col.width, mr: col.mr }} />
              ) : (
                <Skeleton
                  key={colIndex}
                  variant="rectangular"
                  width={col.width}
                  height={20}
                  sx={{ mr: col.mr }}
                />
              )
            ))}
          </Box>
        ))}
      </Box>

      <Box mb={5} mt={10} display="flex" alignItems="center" gap="10%">
        <Skeleton variant="rectangular" width="15%" height={30} />
        <Skeleton variant="rectangular" width="2%" height={30} />
      </Box>

      <Box ml={20} mb={10} mt={3} px={2}>
        {[0, 1].map((row) => (
          <Box key={row} display="flex" gap={2} mb={row === 0 ? 3 : 0}>
            {[...Array(4)].map((_, i) => (
              <Skeleton key={i} variant="rectangular" width="18%" height={30} />
            ))}
          </Box>
        ))}
      </Box>

      <Box display="flex" flexDirection="column" gap={2}>
        <Skeleton variant="rectangular" width="20%" height={30} />
        <Skeleton variant="rectangular" width="15%" height={20} />
      </Box>
    </Box>
  </Box>
);

export default ReservationsClientVoucherSkeleton;
